var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolidAngleDown = function SvgSolidAngleDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B8B8B",
    d: "m11.25 1.445-2.524 2.52-1.54 1.546a1.676 1.676 0 0 1-2.366 0L.75 1.445C.214.91.599 0 1.346 0h9.306c.755 0 1.132.91.598 1.445"
  })));
};
export { SvgSolidAngleDown as ReactComponent };
export default __webpack_public_path__ + "2421a233d30ad76e87033a63911a7fb9.svg";